import React, { useEffect, useState } from 'react';

import {
    AdvancedMarker,
    APIProvider,
    InfoWindow,
    Map,
    Marker,
    Pin
} from '@vis.gl/react-google-maps';
import { Col, Form, message, Modal, Row, Spin } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";

import { Circle } from '../components/Circle';
import noImg from '../assets/static/noImg.jpeg'

import Button from "../components/ReportFormGenerator/Button/Button";
import ZenFormInput from './InputCreater/ZenFormInput';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ZenModal from '../components/ZenModal';
import { useSelector } from 'react-redux';
import { createRoute } from '../utils/CustomFunc';
import SpeechAudio from './LineDashboardMQ/SpeechAudio';
import LinePopup from './LineDashboardMQ/LinePopup';

// import ControlPanel from './control-panel';
// import {MarkerWithInfowindow} from './marker-with-infowindow';

const API_KEY =
    process.env.REACT_APP_GOOGLE_API_KEY;

const VehicleTracker = ({
    button = 'default'
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();

    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const [loading, setLoading] = React.useState(false);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [pageLoading, setPageLoading] = useState(true);
    const [mapData, setMapData] = useState();
    const [center, setCenter] = useState({ lat: 31.326015, lng: 75.576180 });
    const [radius, setRadius] = useState(43000);
    const [form] = Form.useForm();
    const [config, setConfig] = useState()
    const [modalElement, setModalElement] = useState(null);
    const [formData, setFormData] = useState();
    const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker", "slicer"];

    const getMapData = (params) => {
        liracrypt.get('/textapi', { dn: 'VehicleTracker', ...searchParams, ...params })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setMapData({
                        config: data.config,
                        data: data.data
                    })
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                console.error(err);
                ApiErrorComp();
            })
    }
    useEffect(() => {
        liracrypt.get('/miscellaneous/pageconfig', { dictName: 'Catalogue00', ...searchParams })
            .then(res => {
                setConfig({
                    ...res.data.config,
                });
                setModalElement(res.data.config?.modalElements);
                setPageLoading(false);
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }, []);

    const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const zenPopupAction = (zenPopup) => {
        let urlData = { ...zenPopup.params };
        // if (zenPopup?.props) {
        //     urlData[zenPopup?.props] = value;
        // }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    //    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');

                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (zenPop, record) => {
        if (zenPop) {
            setZenModal(zenPop);
            if (zenPop?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPop.params };
                if (zenPop?.api) {
                    zenParams.api = zenPop?.api;
                }
                let route = createRoute({
                    props: zenPop?.props,
                    record,
                    multiProps: zenPop?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPop?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPop?.typ === 'confirmationPopUp') {
                let urlData = { ...zenPop?.onOk?.params };
                // if (zenPop?.onOk?.multiProps) {
                //     zenPop?.onOk?.multiProps.forEach((prop) => {
                //         urlData[prop] = record[prop];
                //     });
                // };
                // if (zenPop?.onOk?.props) {
                //     urlData[zenPop?.onOk?.props] = record[zenPop?.onOk?.props];
                // }

                Modal.confirm({
                    title: zenPop?.text,
                    okText: zenPop?.okButtonText,
                    cancelText: zenPop?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPop?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPop)

        }
    }

    useEffect(() => {
        let interval;
        getMapData({ ...formData });
        console.log(mapData);
        if (mapData?.config?.interval) {
            console.log('I am here');
            interval = setInterval(() => {
                getMapData({ ...formData });
            }, mapData?.config?.interval);
        }
        return () => clearInterval(interval);
    }, [mapData?.config?.interval, formData]);


    const queryElements = (data, index) => {
        if (data.visible !== false) {
            return (
                <React.Fragment key={index}>
                    <ZenFormInput
                        queryLayout={config.queryLayout}
                        onChange={(data.typ === 'dropDown' && data.submitOnChange) ? () => form.submit() : undefined}
                        // layoutPosition={layoutPosition}
                        colSpan={24}
                        form={form}
                        name={data["data_index"]}
                        pname={data["p_data_index"]}
                        label={data["label"]}
                        defaultValue={data["default"]}
                        defaultFrom={data["defaultFrom"]}
                        defaultTo={data["defaultTo"]}
                        typ={data["typ"]}
                        disabled={data["readOnly"]}
                        source={data["source"]}
                        sourceParams={data["sourceParams"]}
                        auxParams={data["auxParams"]}
                        format={data["format"]}
                        errorMessage={data["errorMessage"]}
                        placeHolder={data["placeHolder"]}
                        required={data["required"]}
                        options={data["data"]}
                        from={data["data_index_from"]}
                        to={data["data_index_to"]}
                        url={data["url"]}
                        includeAll={data["includeAll"]}
                        multiSelect={data["multiSelect"]}
                        // searchable={data["isSearchable"]}
                        searchable={true}
                        data={data}

                    />
                </React.Fragment>
            )
        }
    }


    return (
        <Row>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />

            {
                pageLoading ?
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
                    </div> :
                    mapData ?
                        <>
                            <Col span={15} style={{ height: '80vh' }}>
                                <APIProvider apiKey={API_KEY} libraries={['marker']}>
                                    <Map
                                        mapId={'bf51a910020fa25a'}
                                        defaultZoom={mapData?.config?.zoom || 10}
                                        defaultCenter={mapData?.config?.defaultCenter}
                                        gestureHandling={'greedy'}
                                        disableDefaultUI={false}>
                                        {/* simple marker */}
                                        {
                                            mapData?.data?.length ?
                                                mapData?.data?.map((x, i) => (
                                                    <>
                                                        <AdvancedMarker
                                                            position={x.position}
                                                            clickable={true}
                                                            onClick={() => onColumnClick(x.zenPop, x)}
                                                            title={"Click to know more"}>
                                                            <img
                                                                style={{ width: '100%', height: 'auto' }}
                                                                src={require(`../assets/static/${x.icon}`)} />
                                                            {/* <Pin
                                                            background={'#22ccff'}
                                                            borderColor={'#1e89a1'}
                                                            glyphColor={'#0f677a'}></Pin> */}
                                                        </AdvancedMarker>
                                                        <Circle
                                                            radius={x.radius}
                                                            center={x.position}
                                                            onRadiusChanged={() => { }}
                                                            onCenterChanged={() => { }}
                                                            strokeColor={'#0c4cb3'}
                                                            strokeOpacity={1}
                                                            strokeWeight={3}
                                                            fillColor={'#3b82f6'}
                                                            fillOpacity={0.3}
                                                        />
                                                    </>
                                                )) : <></>
                                        }
                                    </Map>

                                </APIProvider>
                            </Col>
                            <Col span={9}>
                                <div className={`AuditSection CreateAudit`} style={{ padding: "10px" }}>
                                    <div className={`ThemeForm phantom-form`}>
                                        <Form
                                            name={`ReportForm `}
                                            form={form}
                                            labelWrap={true}
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                            layout="horizontal"
                                            colon={false}
                                            onFinish={(val) => setFormData(val)}
                                            size="large"
                                        >
                                            <div
                                                className="settingModal"
                                                style={{
                                                    maxHeight: "400px",
                                                    overflowY: "scroll",
                                                    overflowX: "hidden",
                                                }}
                                            >
                                                <Row>
                                                    {modalElement.map((data, index) => {

                                                        if (dtArray.includes(data["typ"])) {

                                                            LocalDict[data["data_index"]] = data["format"]
                                                                ? data["format"]
                                                                : "YYYY-MM-DD hh:mm:ss";
                                                            LocalDict["data_index_from"] = data["data_index_from"];
                                                            LocalDict["data_index_to"] = data["data_index_to"];
                                                        }
                                                        if (data.visible !== false) {
                                                            return (
                                                                <>
                                                                    {
                                                                        config?.queryLayout ?
                                                                            queryElements(data, index) :
                                                                            <Col span={24}>
                                                                                <Row justify={"center"}>
                                                                                    {
                                                                                        queryElements(data, index)
                                                                                    }
                                                                                </Row>
                                                                            </Col>
                                                                    }
                                                                </>


                                                            );
                                                        }
                                                    })}
                                                </Row>

                                            </div>
                                            {
                                                config?.hide_reset && config?.hide_submit ?
                                                    <></> :
                                                    <Row gutter={24} justify="center">
                                                        <Col span={24}>
                                                            {
                                                                button === 'default' ?
                                                                    <Button
                                                                        form={form}
                                                                        hide_submit={config?.hide_submit}
                                                                        // marginLeft={btnMargin ? btnMargin : "320px"}
                                                                        loading={loading}
                                                                        cancelButtonText={config?.hide_reset ? false : "Reset"}
                                                                        submitButtonText={"Submit"}
                                                                    //  resetButton={true}
                                                                    /> :
                                                                    <Button width={"100%"} submitButtonText="Search" form={form} loading={loading} />
                                                            }
                                                        </Col>
                                                    </Row>
                                            }

                                        </Form>
                                    </div>
                                </div>
                            </Col>
                            <SpeechAudio auxFunctions={mapData?.config?.auxFunctions?.tts} />
                            {/* {
                                mapData?.config?.auxFunctions?.popUpMsg?.enable ?
                                    <LinePopup auxFunctions={mapData?.config?.auxFunctions?.popUpMsg} refreshLineDashboard={() => { }} /> : <></>
                            } */}
                        </> : <></>
            }

        </Row>
    );
};

export default VehicleTracker;